import React from "react";
import { connect } from "react-redux";

import PageHeader from "../page/page-header";
import * as Routes from "../routing/routes";
import LayoutWithFooter from "../page/layout-with-footer";
import { getBrand } from "../brand/brand-selectors";
import { actions as routerActions } from "redux-router5";
import SexAndAgeForm from "../general-info/sex-and-age-form";
import AppSecondaryBackground from "../root/app-secondary-background";

function AgeInfoPage({ brand, goTo }) {
  return (
    <AppSecondaryBackground>
      <LayoutWithFooter
        className="AgeInfoPage"
        contentClassName="AgeInfoPage__Content"
      >
        <PageHeader className={"AgeInfoPage__Header"} logo={brand.imagePost} />
        <SexAndAgeForm
          onSubmit={() => goTo(Routes.SELF_DIAGNOSIS_GENERAL_INFO)}
        />
      </LayoutWithFooter>
    </AppSecondaryBackground>
  );
}

const mapState = state => ({
  brand: getBrand(state)
});

const mapDispatch = {
  goTo: routerActions.navigateTo
};

AgeInfoPage = connect(
  mapState,
  mapDispatch
)(AgeInfoPage);

export default AgeInfoPage;



// WEBPACK FOOTER //
// ./src/modules/pages/AgeInfoPage.js